import { ListGroup } from 'react-bootstrap';
import Flex from '@/components/common/Flex';

const TITLE_WIDTHS = ['72%', '58%', '81%', '64%', '75%', '55%', '69%', '77%'];
const TIME_WIDTHS = [72, 88, 64, 96, 80, 70, 84, 76];

type McpHistoryListPreloadProps = {
  rows?: number;
};

export function McpHistoryListPreload({ rows = 8 }: McpHistoryListPreloadProps) {
  return (
    <ListGroup variant="flush" aria-hidden className="placeholder-glow">
      {Array.from({ length: rows }, (_, index) => (
        <ListGroup.Item
          key={index}
          className="px-3 px-md-4 py-3 border-200 position-relative"
        >
          <Flex alignItems="start" className="gap-3 pe-5">
            <span
              className="placeholder rounded flex-shrink-0"
              style={{ width: '1.65rem', height: '1.65rem' }}
            />
            <span className="min-w-0 flex-grow-1">
              <span
                className="placeholder rounded d-block mb-2"
                style={{
                  width: TITLE_WIDTHS[index % TITLE_WIDTHS.length],
                  height: 14
                }}
              />
              <span
                className="placeholder rounded d-block"
                style={{
                  width: TIME_WIDTHS[index % TIME_WIDTHS.length],
                  height: 10
                }}
              />
            </span>
          </Flex>
          <span
            className="placeholder rounded-circle position-absolute top-50 translate-middle-y end-0 me-2"
            style={{ width: '1.7rem', height: '1.7rem' }}
          />
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
}
